let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5gb9N")).then(() => parcelRequire('gTeW1'));